export default __webpack_public_path__ + "static/media/padrao-material.169978bd.png";